module.exports = __webpack_public_path__ + "img/cultureOpen3.a56a31bf.png";